import type { AnyInputBinding } from "./InputBinding/InputBindingUnion.type"
import { InputBindingDevice } from "./InputBindingDevice.enum"

export default function mouseClickEventMatchesInputActionBinding(
  event: MouseEvent,
  input: AnyInputBinding,
): boolean {
  if (input.device === InputBindingDevice.Mouse) {
    if (event.button === input.button && input.click) {
      return true
    }
  }
  return false
}
